import React__default from 'react';
import classNames from 'classnames';
import { determineDataTestIdPrefix, getBaseProps, getAriaProps } from '../../../helpers/propHelpers.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Select = (props) => {
    const decodeOptionsJson = (optionsInput) => {
        const options = typeof optionsInput === 'string' ? JSON.parse(optionsInput) : optionsInput;
        const groupedOptions = {};
        options.forEach((optionObject) => {
            const groupName = optionObject.optGroup ? optionObject.optGroup : 'ungrouped';
            if (groupedOptions[groupName]) {
                groupedOptions[groupName].push(optionObject);
            }
            else {
                groupedOptions[groupName] = [];
                groupedOptions[groupName].push(optionObject);
            }
        });
        return groupedOptions;
    };
    const renderOptions = () => {
        if (!props.options) {
            return React__default.createElement(React__default.Fragment, null);
        }
        const options = decodeOptionsJson(props.options);
        return Object.keys(options).map((optionsKey, loopIndex) => {
            const optionValue = options[optionsKey];
            if (optionsKey !== 'ungrouped') {
                return (React__default.createElement("optgroup", { key: `${optionsKey}-${loopIndex}`, label: `${optionsKey}` }, optionValue.map((option, idx) => {
                    return (React__default.createElement("option", { disabled: option.disabled, key: `${option.value}-${idx}`, value: option.value }, option.text));
                })));
            }
            else {
                const ungrouped = optionValue.map((option, idx) => {
                    return (React__default.createElement("option", { disabled: option.disabled, key: `${option.value}-${idx}`, value: option.value }, option.text));
                });
                return ungrouped;
            }
        });
    };
    const dataTestId = determineDataTestIdPrefix(props, 'select');
    const baseProps = getBaseProps(props);
    const ariaProps = getAriaProps(props);
    const arrowDown = { icon: 'angle-down' };
    const magnifyingGlass = { icon: 'magnifying-glass' };
    return (React__default.createElement(React__default.Fragment, null,
        props.label && (React__default.createElement("label", { htmlFor: "", className: "Select__label" },
            props.label,
            props.required && React__default.createElement("span", { className: "Select__required-indicator" }, "*"))),
        React__default.createElement("div", { className: classNames({
                Select: true,
                'Select--error': props.hasErrors,
                'Select--success': props.hasSuccess,
                [props.className]: props.className,
            }), "data-testid": `${dataTestId}-div` },
            props.isZoomSelect && (React__default.createElement(FontAwesomeIcon, { icon: magnifyingGlass.icon, "data-testid": `${dataTestId}-select-icon2`, className: `Select__left-icon` })),
            React__default.createElement("select", Object.assign({}, baseProps, ariaProps, { name: props === null || props === void 0 ? void 0 : props.name, defaultValue: props.defaultValue, value: props.value, disabled: props.disabled, onChange: props === null || props === void 0 ? void 0 : props.handleChange, onBlur: props === null || props === void 0 ? void 0 : props.handleBlur, onKeyDown: props === null || props === void 0 ? void 0 : props.handleKeyDown, onMouseDown: props === null || props === void 0 ? void 0 : props.handleMouseDown, className: classNames({
                    Select__input: true,
                    'Select__input--error': props.hasErrors,
                    'Select__input--success': props.hasSuccess,
                    'Select__input--small': props.size === 'small',
                    'Select__input--xsmall': props.size === 'xsmall',
                    'Select__input--tiny': props.size === 'tiny',
                }, props === null || props === void 0 ? void 0 : props.className), "aria-disabled": props.disabled, "aria-label": props.arialabel, "aria-describedby": props.ariadescribedby, "data-testid": `${dataTestId}`, id: props === null || props === void 0 ? void 0 : props.id }), renderOptions()),
            React__default.createElement(FontAwesomeIcon, { icon: arrowDown.icon, "data-testid": `${dataTestId}-select-icon`, className: `Select__right-icon` }))));
};

export { Select, Select as default };
//# sourceMappingURL=Select.js.map
